import styled from '@emotion/styled'
import ClientOnlyPortal from './ClientOnlyPortal'

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: 0px 5px 8px 0px ${({ theme }) => theme.colors.lightGray};
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  bottom: 0;
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
`

const Inner = styled.div`
  margin: 0 auto;
  max-width: 52rem;
  padding: 0.5rem;
`

const FixedFooter = ({ children }) => (
  <ClientOnlyPortal selector="#fixed-footer">
    <Container>
      <Inner>{children}</Inner>
    </Container>
  </ClientOnlyPortal>
)

export default FixedFooter
